import { isEmpty, omit } from 'ramda'
import { useChangeSearch, useFilter, useFilterState, useSearch } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React, { Fragment, useState } from 'react'

import FastFilters from './filters/FastFilter'
import FiltersBar from './filters/FiltersBar'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconButton from '../../../components/actions/IconButton'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../components/helpers/Separator'
import ViewsDropdown from '../_shared/ViewsDropdown'

const ControlBar = () => {
  const { t } = useTranslation()

  const { fixedFilterFields } = useFilterState()
  const filter = omit(fixedFilterFields, useFilter())
  const hasFilter = !isEmpty(filter)

  const [isFiltering, setFiltering] = useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  const changeSearch = useChangeSearch()
  const search = useSearch()

  return (
    <Fragment>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <ViewsDropdown active="list" />
        </FlexCol>

        <FlexCol>
          <IconButton iconLeft="BsFunnel" label={t('filter')} transparent noWrap onClick={toggleFilter} />
        </FlexCol>

        <FlexCol flex={3}>
          <FastFilters />
        </FlexCol>

        <FlexCol flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </FlexCol>
      </FlexGrid>
      <Separator weight={4} />

      <FiltersBar open={isFiltering} onClose={hideFilter} />
    </Fragment>
  )
}

export default ControlBar
